// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { TRateRequest, TRateModel, IMappers, TRateResponse, TRateResponseData200 } from './types';
import type { IHttpApi, IHttpApiFetchConfig, FetchResponse } from '@cian/http-api';
import type { IErrorResponseSchema } from '../../entities/schemas/ErrorResponseSchema';

export function createRateModel(parameters: TRateRequest): TRateModel {
  return {
    v: 1,
    apiType: 'public',
    method: 'POST',
    microserviceName: 'cian-chat-bot',
    pathApi: '/v1/rate/',
    response: {
      200: {},
      400: {
        contentType: 'json',
      },
    },
    request: {
      contentType: 'json',
      parameters,
    },
  };
}

export interface IRateOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: TRateRequest;
}

export async function fetchRate<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IRateOptions<TResponse200, TResponse400>): Promise<FetchResponse<TRateResponse> | TResponse200 | TResponse400> {
  const { statusCode, response, headers } = (await httpApi.fetch(
    createRateModel(parameters),
    config,
  )) as FetchResponse<TRateResponse>;
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as TRateResponseData200, headers);
    }
    if (statusCode === 400) {
      return mappers[400](response as IErrorResponseSchema, headers);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as FetchResponse<TRateResponse>;
}
